export default __webpack_public_path__ + "static/media/shield2.304c013c.png";